<template>
  <div class="mb-12">
    <hr class="w-px bg-n-gray border border-n-gray w-full mt-12 mb-12" />
    <div class="flex flex-col md:flex-row mb-6 md:mb-0">
      <div class="w-full md:w-1/3">
        <h2 class="text-2.5xl font-sans-bold text-n-gray-dark font-hairline mb-6">
          Resources
        </h2>
      </div>
      <div class="w-full md:w-2/3" v-if="resources.length > 0">
        <div class="flex flex-col md:flex-row justify-end">
          <router-link :to="{ name: 'resource-create' }" class="button button__medium flex-auto md:flex-initial">
            Add a Resource
          </router-link>
          <div class="ml-0 md:ml-3 mb-3 md:mb-0" />
          <router-link :to="{ name: 'resource-index' }" class="button button-secondary button__medium flex-auto md:flex-initial">
            View all
          </router-link>
        </div>
      </div>
    </div>

    <template v-if="resources.length < 1">
      <div class="text-n-gray-dark text-2xl font-hairline">
        Add your existing services, products, art, workshops and educational offerings--along with the inspiring stories behind your work--for
        inclusion in <NewTabA11y href="https://letsreimagine.org/resources">Reimagine Community Resources</NewTabA11y>.
        Learn more <NewTabA11y href="https://help.letsreimagine.org/hc/en-us/articles/360041714752-What-is-Reimagine-Community-Resources-">here</NewTabA11y>.
      </div>
      <div class="mt-6">
        <router-link :to="{ name: 'resource-create' }" class="button button__medium flex-auto md:flex-initial" style="width: 320px">
          Create your first resource!
        </router-link>
      </div>
    </template>
    <template v-else>
      <div class="pl-5 flex flex-wrap">
        <div v-for="(resource, i) in resources" :key="resource.id" class="w-full md:w-1/3">
          <div :class="cardContainerClasses(i)" class="pb-6">
            <ResourceCard :resource="resource" />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import ResourceCard from "./resources/ResourceCard.vue";
import NewTabA11y from "../../global/a11y/NewTabA11y.vue";

export default {
  name: "ResourcesHome",
  components: {NewTabA11y, ResourceCard},
  computed: {
    ...mapGetters({ resources: 'resources' }),
  },
  mounted() {
    this.$store.dispatch('getAllResources');
  },
  methods: {
    cardContainerClasses(i) {
      if (i % 3 === 0) {
        // first card
        return 'pr-0 md:pr-8';
      } else if (i % 3 === 1) {
        // second card
        return 'px-0 md:px-4  ';
      } else {
        // last card
        return 'pl-0 md:pl-8';
      }
    }
  }
}
</script>

<style scoped>

</style>